import React from 'react'
import { Box, Typography } from '@mui/material'
import FeedbackForm from '@components/feedback/FeedbackForm'

const FeedbackPage: React.FC = () => {
  return (
    <Box maxWidth={700} mx="auto" p={3}>
      <Typography variant="h4" component="h1" gutterBottom>
        Report an Issue or Share Feedback
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Help us improve CigarTrack by reporting bugs or sharing your suggestions.
        You&apos;ll receive a tracking reference number after submission.
      </Typography>
      <FeedbackForm />
    </Box>
  )
}

export default FeedbackPage
